package org.multiplatform.kotfolio.pages.compose.side_effect

import androidx.compose.runtime.Composable
import org.multiplatform.kotfolio.components.KotlinCode
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ul

@Page("/compose/side_effect/remember_observer")
@Composable
fun RememberObserverPage() {
    BlogLayout(
        PageProperties(
            "RememberObserver",
            "RememberObserver in Jetpack Compose lets you hook into the lifecycle of an object that is remembered in composition."

        ),
        BlogProperties("Jetpack Compose", "RememberObserver"))
    {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "RememberObserver - (Location Tracking, SocketManager)",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Usually, we manage resources externally within the Composable. This is predictable, but it exposes lifecycle management details that shouldn’t live in your UI code:",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            KotlinCode(
                code = """
                    class SocketManager(private val url: String) : RememberObserver {
                        
                        override fun onRemembered() {
                            // Automatically triggered when entering the Composition
                            // Warning: Runs on the apply thread (typically Main)—delegate heavy work!
                            connect(url) 
                        }

                        override fun onForgotten() {
                            // Triggered when leaving the Composition
                            disconnect()
                        }

                        override fun onAbandoned() {
                            // Triggered if the composition is discarded before completion
                            disconnect()
                        }

                        private fun connect(url: String) { /* Implementation */ }
                        private fun disconnect() { /* Implementation */ }
                    }
                    
                    @Composable
                    fun ChatScreen(socketUrl: String) {
                        val socketManager = remember { SocketManager() }

                        // UI layer 'knows' how to start and stop the socket
                        DisposableEffect(socketUrl) {
                            socketManager.connect(socketUrl)
                            onDispose { socketManager.disconnect() }
                        }
                    }
                    """.trimIndent()
            )

            SpanText(
                text = "Does this replace ViewModels?",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 2.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "No. ViewModels handle Configuration Changes (like rotation). RememberObserver handles the Composition Lifecycle (adding/removing from the UI tree).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}